<template>
  <div>
    <q-btn
      v-if="jobRun && jobRun.status === 'SUCCESS'"
      :label="postSearch.numPostsMatched"
      round
      @click="openModal"
    />
    <post-search-status
      v-else
      :job-id="postSearch.job.id"
      :job-run="jobRun"
      @changed="onJobRunChange"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { JobRun, PostSearch } from '@/type';
import openModal from '@/components/modal';
import PostSearchModal from './PostSearchModal.vue';
import PostSearchStatus from './PostSearchStatus.vue';
import postSearchRepository from './post-search-repository';

interface Data {
  jobRun: JobRun|null
}

export default defineComponent({
  emits: ['update:postSearch'],
  components: { PostSearchStatus },
  props: {
    postSearch: {
      type: Object as () => PostSearch,
      required: true,
    },
  },
  data(): Data {
    return {
      jobRun: null,
    };
  },
  methods: {
    async onJobRunChange(jobRun: JobRun) {
      this.jobRun = jobRun;
      if (jobRun.status === 'SUCCESS') {
        const search = await postSearchRepository.find(this.postSearch.id);
        this.$emit('update:postSearch', search);
      }
    },
    openModal() {
      const config = {
        parent: this,
        postSearchId: this.postSearch.id,
      };
      openModal(PostSearchModal, config);
    },
  },
});
</script>
